import { Routes } from '@angular/router';
import { LayoutComponent } from './components/layout/layout.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { LoginComponent } from './auth/login/login.component';
import { authGuard, noAuthGuard } from './auth/auth.guard';
import { companyRedirectGuard } from './auth/company-redirect.guard';

export const routes: Routes = [
    {
        path: 'login',
        component: LoginComponent,
        canActivate: [noAuthGuard]
    },
    {
        path: 'login/:usersesion',
        component: LoginComponent
    },
    {
        path: '',
        component: LayoutComponent,
        canActivate: [authGuard],
        children: [
            { path: '', component: DashboardComponent, canActivate: [companyRedirectGuard] },
            { path: 'dashboard/:companyId', component: DashboardComponent }
        ]
    },
    { path: '**', redirectTo: '' }
];
